import _slicedToArray from "C:/Users/mmira/Desktop/gatsby_sites/gatsby-koms/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useContext, useRef, useReducer } from 'react';
import { useIsomorphicLayoutEffect } from './utils';

var defaultEqualityFn = function defaultEqualityFn(a, b) {
  return a === b;
};

export var createUseSelector = function createUseSelector(context) {
  return function (selector) {
    var equalityFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityFn;

    var _useReducer = useReducer(function (c) {
      return c + 1;
    }, 0),
        _useReducer2 = _slicedToArray(_useReducer, 2),
        forceUpdate = _useReducer2[1];

    var _useContext = useContext(context),
        state = _useContext.state,
        subscribe = _useContext.subscribe;

    var selected = selector(state);
    var ref = useRef(null);
    useIsomorphicLayoutEffect(function () {
      ref.current = {
        equalityFn: equalityFn,
        selector: selector,
        state: state,
        selected: selected
      };
    });
    useIsomorphicLayoutEffect(function () {
      var callback = function callback(nextState) {
        try {
          if (ref.current.state === nextState || ref.current.equalityFn(ref.current.selected, ref.current.selector(nextState))) {
            // not changed
            return;
          }
        } catch (e) {// ignored (stale props or some other reason)
        }

        forceUpdate();
      };

      var unsubscribe = subscribe(callback);
      return unsubscribe;
    }, [subscribe]);
    return selected;
  };
};